<template>
    <div class="share-sns-wrapper">
        <!-- 新文章页分享固定位置 -->
        <div class="share-wrapper" v-if="fixed_show">
            <div class="share-wrapper-inner">
                <span class="share-list">
                    <a href="javascript:;" class="icon-movement" data-app="wechattimeline" data-spm-acode="3033" title="分享到朋友圈"></a>
                    <a href="javascript:;" class="icon-wechat" data-app="wechatfriends" data-spm-acode="3034" title="分享给好友"></a>
                </span>
            </div>
        </div>
        <!-- 分享浮层 -->
        <section class="share-dialog" :class="share_dialog_class"  @touchend.prevent="hide" v-else data-spm="share">
            <div class="share-main" :class="share_main_class" @touchend.stop>
                <!-- 第一行 -->
                <div class="share-list-c">
                    <ul class="share-list fist-line">
                        <li  class="item" :data-spm-acode="shareAction" data-spm-click-pm="shareCode:wxf">
                            <span class="icon-container" data-app="wechatfriends" ref="weChat"><i class="icon icon-wechat"></i></span>
                            <span class="text">微信好友</span>
                        </li>
                        <li  class="item" :data-spm-acode="shareAction" data-spm-click-pm="shareCode:wxc">
                            <span class="icon-container" data-app="wechattimeline"><i class="icon icon-movement"></i></span>
                            <span class="text">朋友圈</span>
                        </li>
                        <li  class="item" :data-spm-acode="shareAction" data-spm-click-pm="shareCode:qqf">
                            <span class="icon-container" data-app="qq"><i class="icon icon-qq"></i></span>
                            <span class="text">QQ好友</span>
                        </li>
                        <li  class="item" @click="handleClickPoster" v-if="canShowPosterShare">
                            <div class="icon-container" ref="poster">
                                <img src="../less/images/icon_sharepost@2x.png" class="poster-icon"/>
                                <img class="new-tag" src="../less/images/icon_bubble_new@2x.png"/>
                            </div>
                            <span class="text">分享海报</span>
                        </li>
                        <li class="item" ref="copyLink"
                            v-clipboard:copy="getShareUrl('origin')"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="showCopyDialog" :data-spm-acode="shareAction" data-spm-click-pm="shareCode:link">
                            <span class="icon-container" data-app="copylink"><i class="icon icon-copylink"></i></span>
                            <span class="text">复制链接</span>
                        </li>
                        <li  class="item" :data-spm-acode="shareAction" data-spm-click-pm="shareCode:qqz">
                            <span class="icon-container" data-app="qzone"><i class="icon icon-qzone"></i></span>
                            <span class="text">QQ空间</span>
                        </li>
                        <li  class="item" :data-spm-acode="shareAction" data-spm-click-pm="shareCode:weibo">
                            <span class="icon-container" data-app="sinaweibo"><i class="icon icon-sina"></i></span>
                            <span class="text">新浪微博</span>
                        </li>
                        <li  class="item" :data-spm-acode="shareAction" data-spm-click-pm="shareCode:hy">
                            <a class="btn-huyou" @click="shareHuyouAppHandler" href="javascript:;">
                                <span class="icon-container" data-app="huyou"><i class="icon icon-huyou"></i></span>
                                <span class="text">狐友</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <!-- 第二行 -->
                <ul class="share-list second-line" v-if="showSecondLine">
                    <li  class="item" @click="handleOpenNav" :data-spm-acode="secondNavClick" data-spm-click-pm="shareCode:allnav">
                        <span class="icon-container"><i class="icon icon-all-nav"></i></span>
                        <span class="text">全站导航</span>
                    </li>
                    <li class="item" :data-spm-acode="secondNavClick" data-spm-click-pm="shareCode:fb">
                        <a :href="feedbackUrl" data-spm-data="fb">
                            <span class="icon-container">
                                <img :src="FBIcon" class="ghb">
                            </span>
                            <span class="text">举报/反馈</span>
                        </a>
                    </li>
                    <li class="item" @click="handleNoBarrier" :data-spm-acode="secondNavClick" data-spm-click-pm="shareCode:barrierfree">
                        <span class="icon-container"><i class="icon icon-no-obstruct "></i></span>
                        <span class="text">无障碍模式</span>
                    </li>
                    <li class="item" @click="handleCare" :data-spm-acode="secondNavClick" data-spm-click-pm="shareCode:caremode">
                        <span class="icon-container">
                            <img :src="GHBIcon" class="ghb" alt="ghb icon">
                        </span>
                        <span class="text">关怀模式</span>
                    </li>
                </ul>
                <footer class="oper-cancel" @click="clickHide">取消</footer>
            </div>
        </section>
        <div class="copy-fail-dialog" v-show="show_copy_dialog" @touchmove.prevent @click="hideCopyDialog">
            <main class="dialog" @click.stop>
                <i class="close icon-close" @click="hideCopyDialog"></i>
                <h4>长按复制以下链接，粘贴给好友吧！</h4>
                <h5>{{url}}</h5>
            </main>
        </div>

        <!-- 分享失败提示框 -->
        <div class="share-fail-dialog" v-show="share_fail" @touchmove.prevent>
            <div class="dialog" @click.stop>
                <img class="icon_image" src="https://statics.itc.cn/mptc-mpfe/img/article/icon_copyed.png" />
                <div class="main_text">已复制链接</div>
                <div class="extra_text">快去分享给好友吧!</div>
                <div class="confirm_button" @click="hideShareFailDialog">我知道了</div>
            </div>
        </div>

    </div>
</template>

<script>
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);
import Supporter from '../utils/supporter';
import ShareSns from 'common-components/lib/shareJs/index';
import API from '../js/api';
import SohuStat from '../statistics/sohu-stat';
import CallHuyouAapp from '../utils/call-huyou-app.js';
import GHBIcon from "../less/images/icon_care_empty4@2x.png"
import FBIcon from "../less/images/icon_feedback_empty4@2x.png"
import Utils from '../utils/util.js'
import PosterShare from '../vue_components/article-main/poster-share.vue'
import { acodeConfig } from '@/config/spmConfig';

const feedbackHrefMap = {
        'prod':'//m.sohu.com/feedback',
        'test':'//test-m.sohu.com/feedback',
        'pre':'//m.sohu.com/feedback',
    }

const feedbackHref = feedbackHrefMap[window.deployEnv || 'prod'] + `?articleUrl=${window.location.origin + window.location.pathname}`
export default {
    props: {
        newsId: {
            type: String,
            default: ''
        },
        url: {
            type: String,
            default: window.location.href
        },
        title: {
            type: String,
            default: (window.cfgs && window.cfgs.title) || document.title
        },
        desc: {
            type: String,
            default: ''
        },
        image: {
            type: String,
            default: ''
        },
        // 文章模版类型 deep-深度
        type: {
            type: String,
            default: 'normal'
        },
        from: {
            type: String,
            default: '手机搜狐网'
        },
        shareOnceCode: {
            type: String,
            default: ''
        },
        sharebackOnceCode: {
            type: String,
            default: ''
        },
        fixed_show : {
            type : Boolean,
            default : false
        },
        stat_data :{
            type : Object,
            default : function() {
                return {}
            }
        },
        is_weixin: {
            type: Boolean,
            default: Supporter.isWeixin
        },
        need_share: {
            type: Boolean,
            default: false
        },
        // 黑名单，posterShare:海报分享
        blackList: {
            type: Array,
            default: () => {
                return []
            },
            required:false,
        }
    },
    data () {
        return {
            show_dialog: false,
            mobile: Supporter.isSafari ? 'safari' :
                        Supporter.isOppoOwn || Supporter.isUC || Supporter.isQQ ? 'oppo_uc_qq':
                            Supporter.isBaiduboxapp || Supporter.isChrome ? 'baidu_chrome':
                                'others',
            hideFailLayerTimer: null,
            show_copy_dialog: false,
            share_fail: false,
            shareTo: 'wechattimeline',
            os: Supporter.os,
            shareSnsInstance: null,
            showSecondLine: false, // 是否展示第二行
            shareAction: acodeConfig.shareAction, // 通过更多唤起的弹框：10083  通过右下角分享唤起：3032
            secondNavClick: acodeConfig.floatPanelNavClick,
            cancelAcode: acodeConfig.cancelShare, // 取消弹框事件码
            locationURL: location.href,
            GHBIcon,
            FBIcon, // 反馈、举报icon
            feedbackUrl: feedbackHref,
        }
    },
    watch: {
        newsId: function (newVal, oldVal) {
            if(newVal !== oldVal) {
                this.init();
            }
        },
        show_dialog: function(newVal, oldVal) {
            if(newVal) {
                this.renderPoster()
                setTimeout(()=>{
                    Utils.domDidChange({target: 'share'})
                },1000)
            }
        }
    },
    methods: {
        renderPoster() {
            // 只渲染一次
            const shareDom = document.querySelector('#posterShare poster-share')
            if (shareDom) {
                new Vue({
                    el: '#posterShare',
                    components: {
                        PosterShare
                    }
                })
                }
        },
        // 分享海报
        handleClickPoster() {
            window?.sohuSpm?.sendAction({
                acode: acodeConfig.shareAction,
                clkParam: 'shareCode:fxhb'
            })
            window.EVENT_BUS.$emit('showPoster')
            // 关闭分享浮层
            this.hide()
        },
        // 打开全站导航
        handleOpenNav() {
            window.EVENT_BUS.$emit('openNavLayer')
            this.hide()
        },
        // 无障碍点击
        async handleNoBarrier(){
            const { startAria } = await import('fed_sharedlib/startAria')
            startAria('wza')
            this.hide()
        },
        async handleCare(){
            const { startAria } = await import('fed_sharedlib/startAria')
            startAria('ghb')
            this.hide()
        },
        shareHuyouAppHandler() {
            let appNewsPageUrl = this.url.split("?")[0];
            let shareImage = document.querySelector('#articleContent img.content-image');
            CallHuyouAapp.shareToHuYou({
                appNewsPageUrl:appNewsPageUrl,
                image: this.image || (shareImage && shareImage.getAttribute('src') && shareImage.getAttribute('src').replace(/^\/\//, 'https://')) ,
                title: this.title,
                });
        },
        init() {
            var shareImage = document.querySelector('#articleContent img.content-image');
            var articleShareData = {
                newsId: this.newsId,
                url: this.url,
                title: this.title,
                desc: this.desc,
                image: this.image || (shareImage && shareImage.getAttribute('src')),
                from: this.from,
                shareOnceCode: this.shareOnceCode,
                sharebackOnceCode: this.sharebackOnceCode,
                failCallback: this.shareFailDialog,
                completeCallback : this.completeCallback,
                statData: this.stat_data
            };
            if(articleShareData.image) {
                articleShareData.image = articleShareData.image.replace(/^\/\//, 'http://');
            }
            if(!this.shareSnsInstance) {
                // 绑定点击事件
                this.shareSnsInstance = new ShareSns(articleShareData, document.querySelector(this.fixed_show ? '.share-wrapper' : '.share-dialog'));
                this.shareSnsInstance.init({
                    isNeedCheckShareByQQBrowser: this.need_share,
                    isWeixin: this.is_weixin
                });
            }else {
                this.shareSnsInstance.update(articleShareData);
            }
        },
        // 点击点击取消按钮
        clickHide() {
            window.sohuSpm.sendAction({
                acode: this.cancelAcode
            });
            this.hide()
        },
        hide(){
            this.show_dialog = false;
        },
        show(params){
            this.show_dialog = true;
            this.showSecondLine = params?.showSecondLine
            this.cancelAcode = acodeConfig.cancelShare
            SohuStat.sendActionStat('10120045');
            SohuStat.sendStatistics('ev',{
                location : 'm-article_share'
            });
        },
        onCopy (e) {
            var that = this;
            window.h5_sohu.plugin.api.call('toast', {
                text: '复制成功',
                type: 1
            }, function () {
                SohuStat.sendActionStat('10041');
                that.hide();
            });
        },
        getShareUrl(type) {
            var strategyGroup = ['origin'] // 采用strategyId的type
            var codeMap = {'origin':'00014','wechattimeline':'010004_wappyqfzlj','wechatfriends':'010004_wapwxfzlj','qq':'010004_wapqqfzlj','qqZone':'010004_wapqqkjfzlj'}
            const transCode = codeMap[type]
            var resultUrl = strategyGroup.indexOf(type) >= 0 ? ShareSns.prototype._addQueryArgs(this.url, {'strategyid': transCode}) : this.URLAddParam(this.url, transCode)
            var title = `《${document.title}》`
            // 深度文章页
            if(this.type == 'deep') {
                var totalInfo = resultUrl + title + ',搜狐网出品深读频道：精选，更精彩'
            }else {
                var totalInfo = resultUrl + title + '-上搜狐网，查看更多精彩内容'
            }
            return totalInfo
        },
        URLAddParam(url, transCode) {
            if(url.indexOf("?") > -1) {
                if(url.indexOf('_trans') > -1) {
                    return this.replaceParam(url, '_trans_', transCode)
                } else {
                    return `${url}&${transCode}`
                }
            } else {
                return `${url}?${transCode}`
            }
        },
        replaceParam(url, param, value) {
            const re = new RegExp(`[?&]${param}=.+`);
            return url.replace(re, `&${param}=${value}`);
        },
        copyToClipboard(txt) {
            if(typeof document.execCommand =="function"){
                var tempObj = document.createElement('input');
                tempObj.setAttribute('value',txt);
                document.body.appendChild(tempObj);
                tempObj.select();
                document.execCommand('copy')
                document.body.removeChild(tempObj);
            }
            else if (window.clipboardData) {
                window.clipboardData.clearData();
                clipboardData.setData("Text", txt);
            } else if (window.netscape) {
                try {
                    netscape.security.PrivilegeManager.enablePrivilege("UniversalXPConnect");
                } catch (e) {
                    console.log('error:',e)
                }
                var clip = Components.classes['@mozilla.org/widget/clipboard;1'].createInstance(Components.interfaces.nsIClipboard);
                if (!clip) return;

                var trans = Components.classes['@mozilla.org/widget/transferable;1'].createInstance(Components.interfaces.nsITransferable);
                if (!trans) return;

                trans.addDataFlavor("text/unicode");
                var str = new Object();
                var len = new Object();
                var str = Components.classes["@mozilla.org/supports-string;1"].createInstance(Components.interfaces.nsISupportsString);
                var copyText = txt;
                str.data = copyText;
                trans.setTransferData("text/unicode", str, copyText.length * 2);
                var clipId = Components.interfaces.nsIClipboard;
                if (!clip) return false;
                clip.setData(trans, null, clipId.kGlobalClipboard);
            }
        },
        hideCopyDialog() {
            this.show_copy_dialog = false;
        },
        showCopyDialog() {
            this.hide();
            this.show_copy_dialog = true;
        },
        shareFailDialog(app){ // 失败回调
            this.hide();
            this.shareTo = app || '';
            this.share_fail = true;
            this.copyToClipboard(this.getShareUrl(app))
        },
        hideShareFailDialog(){
            clearTimeout(this.hideFailLayerTimer);
            this.share_fail = false;
        },
        completeCallback(){
            setTimeout(() => {
                this.hide();
            },3000);
        },
        internalFunc(stay = 3000){
            return new Promise(resolve => setInterval(resolve, stay));
        },
    },
    mounted () {
        var self = this;
        this.init();
        if(!this.fixed_show){
            API.register("show_share", (params, cal)=> {
                console.log('param',params)
                this.show(params);
                if (typeof cal === 'function') cal();
            })
            API.register("hide_share", function (params, cal) {
                self.hide(params);
                if (typeof cal === 'function') cal();
            });
            API.register('shareToWeChat', function() {
                if(self.shareSnsInstance){
                    self.shareSnsInstance.shareto("wechatfriends")
                }
                window.sohuSpm.sendAction({
                    acode: acodeConfig.shareAction,
                    clkParam: 'shareCode:wxf,sharePlace:articleEnd'
                });
            })
            API.register('wechattimeline', function() {
                if(self.shareSnsInstance){
                    self.shareSnsInstance.shareto("wechattimeline")
                }
            })
            API.register('sinaweibo', function() {
                if(self.shareSnsInstance){
                    self.shareSnsInstance.shareto("sinaweibo")
                }
            })
            API.register('copyLink', function() {
                self.$refs.copyLink.dataset.spmClickPm = 'shareCode:link,sharePlace:articleEnd'
                self.$refs.copyLink.click()
                self.$refs.copyLink.dataset.spmClickPm = 'shareCode:link'
            })
        }

        self.$emit('share-sns-mounted');
    },
    computed: {
        canShowPosterShare(){
            return window.cfgs.Sgrade != '3' && /\/a/.test(window.location?.pathname) && !this.blackList?.includes('posterShare')
        },
        isOthersMobile: function () {
            return this.mobile === 'others';
        },
        hasShareIcon: function () {
            if(this.mobile !== 'others'){
                return true;
            }else{
                return false;
            }
        },
        shareIconClass: function () {
            if(this.mobile === 'baidu_chrome') {
                return 'icon-share-baidu';
            }else if(this.mobile === 'safari') {
                return 'icon-share-safari';
            }else if(this.mobile === 'oppo_uc_qq') {
                return 'icon-share-android';
            }
        },
        share_dialog_class(){
            return this.show_dialog ? 'on' : '';
        },
        share_main_class(){
            return this.show_dialog ? 'on' : '';
        },
        weixin_share_text() {
            return this.shareTo == 'wechatfriends'
                ? '分享给朋友'
                : '分享到朋友圈'
        },
    }
}
</script>

<style lang="less" rel="stylesheet/less">
    /* 文章页正文部分底部的分享，图标和底部浮层不一致 */
    .share-wrapper, .share-fail-dialog-weixin{
        .icon-movement {
            background-image: url('../less/images/moments_new_test.png');
        }

        .icon-wechat {
            background-image: url('../less/images/ic_WeChat_new.png');
        }
    }

    /* common */
    .icon-movement {
        background-image: url('../less/images/share/ic_moments.png');
    }

    .icon-wechat {
        background-image: url('../less/images/share/ic_WeChat.png');
    }

    .icon-sina {
        background-image: url('../less/images/share/ic_Weibo.png');
    }

    .icon-qq {
        background-image: url('//statics.itc.cn/WAP_base/qq@2x.png');
    }

    .icon-qzone {
        background-image: url('../less/images/share/ic_Qzone.png');
    }
    .icon-huyou {
        width: 60px!important;
        height: 60px!important;
        background-image: url('../less/images/share/ic_huyou.png');
    }
    .icon-copylink {
        background-image: url('//statics.itc.cn/WAP_base/link@2x.png');
    }
    .icon-no-obstruct {
        background-image: url('//statics.itc.cn/WAP_base/no-obstruct@2x.png');
    }
    .icon-all-nav {
        background-image: url('//statics.itc.cn/WAP_base/icon_menu_empty4@2x.png');
    }

    /* share-wrapper */
    .share-wrapper {
        padding: 20px 0 36px 0;/*px*/
        width: 100%;
        box-sizing: border-box;
        .share-wrapper-inner {
            display: flex;
            em {
                margin-right: 24px;/*px*/
                line-height: 80px;/*px*/
                font-size: 28px; /*px*/
                color: #a4a4a4;
            }
            .share-list {
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex: 1 1 80px;/*px*/
                a {
                    display: block;
                    width: 92px;/*px*/
                    height: 92px;/*px*/
                    background-size: cover;
                }
            }
        }
    }

    /* share-dialog */
    .share-dialog {
        background-color: rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 100%;
        position: fixed;
        z-index: 1111;
        top: 0;
        left: 0;
        visibility: hidden;
        animation: all .3s;
        &.on{
            visibility: visible;
        }
        .share-main {
            transition: .3s;
            will-change: transform;
            transform: translateY(100%);
            background: #fff;
            width: 100%;
            position: absolute;
            left: 0;
            bottom: 0;
            box-sizing: border-box;
            text-align: center;
            .title {
                font-size: 34px; /*px*/
                line-height: 54px;/*px*/
            }
            &.on{
                transform: translateY(0);
            }
        }
        .share-list-c{
            overflow-x: auto;
            background: #f5f5f5;
            &::-webkit-scrollbar{
                display:none; /* ChromeSafari */
            }
            scrollbar-width: none;
        }
        .fist-line{
            width: 960px;/*px*/
            box-sizing: border-box;
            justify-content: space-between;
        }
        .share-main > .second-line{
            padding-top: 0;
            .item {
                padding-right: 11px;/*px*/
            }
        }
        .share-list {
            padding: 40px 24px 4px;/*px*/
            transition: max-height 0.3s ease-out;
            display: flex;
            background: #f5f5f5;
            .item {
                width: 120px;/*px*/
                padding-bottom: 40px;/*px*/
                .icon-container {
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                    width: 92px;/*px*/
                    height: 92px;/*px*/
                    border-radius: 50%;
                    background-color: #ffffff;
                    position: relative;
                    .ghb {
                        width: 50px;/*px*/
                        height: 50px;/*px*/
                    }
                    .poster-icon {
                        width: 52px;/*px*/
                        height: 52px;/*px*/
                    }
                    .new-tag {
                        position: absolute;
                        right: -16px;/*px*/
                        top: 4px;/*px*/
                        width: 54px;/*px*/
                        height: 28px;/*px*/
                    }
                }
                .icon {
                    width: 50px;/*px*/
                    height: 50px;/*px*/
                    display: block;
                    background-size: cover;
                }
                .text {
                    margin-top: 20px;/*px*/
                    display: block;
                    color: #3C3C3D;
                    font-size: 24px; /*px*/
                }
            }

            .btn-huyou {
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                outline: none;
            }
        }
        .menuUnFold{
            max-height: 420px;/*px*/
        }
        .oper-cancel {
            height: 100px;/*px*/
            line-height: 100px;/*px*/
            text-align: center;
            font-size: 32px;/*px*/
            color: #3C3C3D;
        }
    }

    /* 分享失败浮层 */
    .share-fail-dialog {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 1555;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.5);;
        .dialog{
            position: relative;
            width: 622px;/*px*/
            height: 442px;/*px*/
            background: #FFFFFF;
            border-radius: 8px;/*px*/
            display: flex;
            flex-direction: column;
            align-items: center;
            .icon_image{
                width: 112px;/*px*/
                height: 112px;/*px*/
                margin-top: 48px;/*px*/
            }
            .main_text{
                height: 50px;/*px*/
                font-size: 36px;/*px*/
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #111111;
                line-height: 50px;/*px*/
                margin-top: 32px;/*px*/
            }
            .extra_text{
                height: 40px;/*px*/
                font-size: 28px;/*px*/
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
                line-height: 40px;/*px*/
                margin-top: 8px;/*px*/
            }
            .confirm_button{
                width: 494px;/*px*/
                height: 72px;/*px*/
                background: #F8F8F8;
                font-size: 28px;/*px*/
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #111111;
                line-height: 72px;/*px*/
                margin-top: 48px;/*px*/
                text-align: center;
            }
        }
    }

    /* 微信分享失败浮层 */
    .share-fail-dialog-weixin {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 1555;
        .dialog{
            position: absolute;
            right: 32px;/*px*/
            top: 0;
            width: 482px;/*px*/
            height: 184px;/*px*/
            padding: 58px 44px 34px;/*px*/
            border-radius: 6px;/*px*/
            box-sizing: border-box;
            color: #fff;
            background: url('../less/images/wx_dialog.png');
            background-size: 100%;
            font-size: 28px;/*px*/
            text-align: left;
            p{
                position: relative;
                height: 46px;/*px*/
                line-height: 46px;/*px*/
                i{
                    display: inline-block;
                    margin: 0 15px;/*px*/
                }
                .icon-movement, .icon-wechatfriends{
                    width: 36px !important;/*px*/
                    height: 36px !important;/*px*/
                    background-size: 100%;
                    transform: translateY(25%);
                }
                .icon-more-wx {
                    width: 34px;/*px*/
                    height: 6px;/*px*/
                    background: url('../less/images/more.png') no-repeat;
                    background-size: 100%;
                    transform: translateY(-50%);
                }
                .icon-more-android {
                    width: 6px;/*px*/
                    height: 34px;/*px*/
                    background: url('../less/images/more-android.png') no-repeat;
                    background-size: 100%;
                    transform: translateY(25%);
                }
                .icon-wechatfriends {
                    background: url('../less/images/wx_share.png');
                    background-size: 100%;
                }
            }
        }
    }



// 复制失败浮层
.copy-fail-dialog {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1666;
    display: flex;
    align-items: center;
    justify-content: center;
    .dialog {
        position: relative;
        width: 80%;
        padding: 42px 58px 42px;/*px*/
        box-sizing: border-box;
        color: #fff;
        background-color: rgba(63, 65, 71, .93);
        color: #fff;
        .close {
            position: absolute;
            right: 18px;/*px*/
            top: 10px;/*px*/
            font-size: 28px;/*px*/
        }
        h3{
            font-size: 32px;/*px*/
            padding-bottom: 42px;/*px*/
            display: flex;
            align-items: center;
            justify-content: center;
            .warn{
                width: 44px;/*px*/
                height: 44px;/*px*/
                margin-right: 14px;/*px*/
                background: url('../less/images/info-warn.svg') no-repeat center center;
                background-size: contain;
            }
        }
        h4 {
            font-size: 26px;/*px*/
            padding-bottom: 10px;/*px*/
        }

        h5 {
            font-size: 26px;/*px*/
            word-break: break-all;
        }
    }
}

</style>